"use client";
import Thumbnail from "@marginly/ui/components/thumbnail";
import { useRouter } from "next/navigation";
import { Suspense } from "react";

import { ChainSegmentParams } from "@/app/types";
import { TokenEarnInfo } from "@/types/api";

import Space from "../common/space";
import { ChainsTab, ChainsTabItem, OverflowContainer } from "../common/tabs";
import { usePrices } from "../util/use-prices";
import { PoolSection } from "./earn-section";
import {
  arbitrumSections,
  blastPools,
  mainnetSections,
} from "./earn-sections-info";
import { CoinGrid } from "./styled";

const getSectionsByChain = (chain: string) => {
  if (chain === "arbitrum") {
    return arbitrumSections;
  }
  if (chain === "mainnet") {
    return mainnetSections;
  }
  return blastPools;
};

const networks = [
  { id: "arbitrum", label: "Arbitrum", image: "/images/network/arbitrum.svg" },
  { id: "mainnet", label: "Ethereum", image: "/images/network/ethereum.svg" },
  { id: "blast", label: "Blast", image: "/images/network/blast.svg" },
];

export default function Earn(
  props: ChainSegmentParams & { tokenInfoList?: TokenEarnInfo[] },
) {
  const router = useRouter();

  const sections = getSectionsByChain(props.chain);

  const priceByToken = usePrices();

  return (
    <Suspense>
      <OverflowContainer>
        <ChainsTab>
          {networks.map(({ id, label, image }) => {
            return (
              <ChainsTabItem
                className={props.chain !== id ? "" : "active"}
                onClick={() => router.push(`/${id}/earn`)}
                key={id}
              >
                <Thumbnail md rectangle>
                  <img
                    src={image}
                    alt={label}
                    style={{ filter: "invert(var(--svg-invert))" }}
                  />
                </Thumbnail>
                <div>{label}</div>
              </ChainsTabItem>
            );
          })}
        </ChainsTab>
      </OverflowContainer>
      <Space height={24} heightMobile={24} />
      <CoinGrid>
        {sections.map((section, key) => {
          return (
            <PoolSection
              id={section.id}
              title={section.title}
              isOpen={section.isOpen}
              pools={section.pools}
              chain={props.chain}
              priceByToken={priceByToken}
              key={key}
            />
          );
        })}
      </CoinGrid>
    </Suspense>
  );
}
